import { Col, Row, Steps, Image, TabsProps, Tabs, Space } from 'antd';
import { MainLayout } from 'components';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { DownloadIcon, Edit2, UploadIcon } from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import ProductInfo from 'components/Modules/Product/ProductInfo';
import HistoryPhanBo from 'components/Modules/Product/HistoryPhanBo';
import HistoryUpdate from 'components/Modules/Product/HistoryUpdate';
import ListAttachFile from 'components/Modules/Product/ListAttachFile';
import { category, tag, status, supplier, defaultImage } from 'assets/images';
import Button from 'components/Button';
import ProductApi from 'apis/ProductApi';
import { useQuery } from 'react-query';
import handleError401 from 'utils/handleError401';
import { IProduct, IProductImage } from 'interface/product.interface';
import { STATUS } from 'constants/reponseStatus';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import ListImage from 'components/Modules/Product/ListImage';
import pageTitleStore from 'store/pageTitleStore';
import BomInfo from 'components/Modules/Product/BomInfo';

interface Iparam {
  code: string;
}

export default function ProductDetailPage(): JSX.Element {
  const { code } = useParams<Iparam>();
  const step = useCategoryManagementStore((state) => state.step);
  const [product, setProduct] = useState<IProduct>();
  const [images, setImages] = useState<IProductImage[]>([]);
  const [mainPic, setMainPic] = useState<IProductImage>();
  const [mainIndex, setMainIndex] = useState<number>();
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Thông tin chi tiết`,
      children: <ProductInfo product={product} />,
    },
    {
      key: '2',
      label: `BOM`,
      children: <BomInfo product={product} />,
    },
    {
      key: '3',
      label: `Hình ảnh`,
      children: (
        <ListImage
          product={product}
          images={images}
          onAddNewImage={(image) => {
            setImages([image, ...images]);
            refetch();
          }}
          onDeleteImage={() => {
            refetch();
          }}
        />
      ),
    },
    // {
    //   key: '4',
    //   label: `Lịch sử phân bổ`,
    //   children: <HistoryPhanBo />,
    // },
    // {
    //   key: '5',
    //   label: `Tình trạng bán hàng`,
    //   children: `Content of Tab Pane 3`,
    // },
    // {
    //   key: '6',
    //   label: `Lịch sử thay đổi`,
    //   children: <HistoryUpdate />,
    // },
    // {
    //   key: '7',
    //   label: `File đính kèm`,
    //   children: <ListAttachFile />,
    // },
  ];

  const { data, isLoading: isLoading } = useQuery(
    ['getyDetail'],
    () => ProductApi.getyDetail(code),
    {
      onSuccess: (response) => {
        if (response.status === STATUS.SUCCESS) {
          const res = response.data;
          setProduct(res);
          setMainPic(res.image_default ?? defaultImage);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { refetch, isLoading: isLoadingImages } = useQuery(
    ['getListImage'],
    () => ProductApi.getListImage(code),
    {
      onSuccess: (response) => {
        if (response.status === STATUS.SUCCESS) {
          setImages(response.data);
          setMainPic(
            response.data.length != 0 ? response.data[0] : defaultImage
          );
          setMainIndex(0);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );
  // TODO: FIX when have suitable API
  // Still hard code in Breadcrumb: 'DANH MỤC HÀNG MỚI_CHIẾN LƯỢC HÀNG HÓA'.
  // Because now don't have related portfolio, so hard code here
  useEffect(() => {
    if (product) {
      setTitle(product?.product_name || '');
      setBreadcrumb([
        { title: <p>Sản phẩm</p> },
        // { title: 'DANH MỤC HÀNG MỚI_CHIẾN LƯỢC HÀNG HÓA' },
        { title: <a href="">{product?.product_name}</a> },
      ]);
    }
  }, [product]);

  console.log(product);

  return (
    <MainLayout isLoading={isLoading}>
      <Content className="mb-4">
        {/* <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          className="mb-1"
        >
          <Col span={12} className="flex justify-end">
            <Space>
              <Button>
                <Edit2 />
                Chỉnh sửa
              </Button>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
              >
                <DownloadIcon />
                Tải file excel
              </Button>
            </Space>
          </Col>
        </Row> */}
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col flex="230px">
            <Image.PreviewGroup
              items={images.map((image) => image.image_path)}
              preview={{ current: mainIndex }}
            >
              <Image
                className="border border-solid border-neutral-90 rounded-lg"
                width={252}
                height={230}
                src={
                  mainPic
                    ? mainPic.image_path
                    : product?.image_default
                    ? product?.image_default
                    : ''
                }
              />
            </Image.PreviewGroup>
            <div>
              <div
                className="flex flex-row"
                style={{ gap: '4px', overflowX: 'scroll', width: '252px' }}
              >
                {images.map((image, index) => (
                  <div key={index}>
                    <Image
                      className="product-image-item bg-neutral-95 border border-solid rounded-lg active"
                      width={60}
                      height={60}
                      preview={false}
                      src={image.image_path ? image.image_path : ''}
                      onClick={() => {
                        setMainPic(image);
                        setMainIndex(index);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Col>
          <Col flex="auto">
            <div className="text-primary-50 text-base font-bold mb-2">
              [{product?.product_code}] {product?.product_name}
            </div>
            <div className="text-base font-bold mb-6">
              {formatCurrencyVND(product?.price || 0)}
            </div>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-4">
              <Col className="" span={12}>
                <div className="text-base font-bold text-neutral-40 flex gap-2">
                  <img src={category} />
                  <div>Danh mục</div>
                </div>
                <div className="text-sm font-semibold text-neutral-70 ml-8">
                  DANH MỤC HÀNG MỚI_CHIẾN LƯỢC HÀNG HÓA
                </div>
              </Col>
              <Col className="" span={12}>
                <div className="text-base font-bold text-neutral-40 flex gap-2">
                  <img src={supplier} />
                  <div>Nhà cung cấp</div>
                </div>
                <div className="text-sm font-semibold text-neutral-70 ml-8">
                  {product?.source_of_supply || '-'}
                </div>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={12}>
                <div className="text-base font-bold text-neutral-40 flex gap-1">
                  <img src={status} />
                  <div>Trạng thái sản phẩm</div>
                </div>
                <div className="text-sm font-semibold text-neutral-70 ml-8">
                  {product?.status}
                </div>
              </Col>
              <Col className="" span={12}>
                <div className="text-base font-bold text-neutral-40 flex gap-1">
                  <img src={tag} />
                  <div>Nhãn hàng</div>
                </div>
                <div className="text-sm font-semibold text-neutral-70 ml-8">
                  {product?.prod_grp3_name}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
      <Content>
        <Tabs defaultActiveKey="1" items={items} />
      </Content>
    </MainLayout>
  );
}
